export function safeURL(value) {
    try {
        const url = new URL(value);
        return ['https:', 'http:'].includes(url.protocol) && !url.username && !url.password ? url.href : null;
    } catch (_) { return null; }
}
// Thumbnail URLs are issued by the configured service, never by the source website.
export function bookmarkThumbnail(item, base) {
    const thumbnail = item.thumbnail;
    if (!thumbnail || !['image', 'icon'].includes(thumbnail.kind) ||
        ![thumbnail.width, thumbnail.height].every(value => Number.isInteger(value) && value > 0 && value <= 256)) return null;
    try {
        const origin = new URL(base);
        const url = new URL(thumbnail.url);
        const prefix = `/api/v1/bookmarks/${encodeURIComponent(item.id)}/thumbnail/`;
        if (origin.protocol !== 'https:' || origin.username || origin.password ||
            url.origin !== origin.origin || url.username || url.password || url.search || url.hash ||
            !url.pathname.startsWith(prefix) || !/^[a-f0-9]{64}$/.test(url.pathname.slice(prefix.length))) return null;
        return {...thumbnail, url: url.href};
    } catch (_) { return null; }
}
// Summaries contain Telegram/Markdown punctuation escapes. Render them as plain text.
export function plainText(value) { return typeof value === 'string' ? value.replace(/\\([\\`*_{}\[\]()#+\-.!>])/g, '$1') : ''; }
export function localized(item, locale) { return item.translations?.[locale] || item.translations?.['en-US'] || item.translations?.['zh-TW'] || item; }
const savedDayFormatter = new Intl.DateTimeFormat('en-CA', {timeZone: 'Asia/Taipei', year: 'numeric', month: '2-digit', day: '2-digit'});
export function savedDay(value) { return savedDayFormatter.format(new Date(value)); }
export function bookmarkPage(response) {
    if (!Array.isArray(response?.items)) throw new Error('Invalid bookmark response');
    const items = response.items.filter(item => item && safeURL(item.url) && Number.isFinite(Date.parse(item.saved_at)) && typeof item.id === 'string');
    if (response.items.length && !items.length) throw new Error('No valid bookmarks in response');
    return {items, cursor: typeof response.next_cursor === 'string' && response.next_cursor ? response.next_cursor : null};
}
export function mergeBookmarks(existing, incoming) {
    const byId = new Map(existing.map(item => [item.id, item]));
    incoming.forEach(item => byId.set(item.id, item));
    return [...byId.values()].sort((a, b) => Date.parse(b.saved_at) - Date.parse(a.saved_at));
}
export function bookmarkDays(items) {
    const days = new Map();
    items.forEach(item => {
        const day = savedDay(item.saved_at);
        if (!days.has(day)) days.set(day, []);
        days.get(day).push(item);
    });
    return [...days].sort(([a], [b]) => b.localeCompare(a)).map(([day, items]) => ({day, items}));
}
